/* The AI assistant's settings. Metadata first: a state, three conditions, then forms that read as
   forms. Tokens only (ADR-0007). The grid collapses to one column on a phone. */

.statusRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 24px;
  margin: 0 0 10px;
}

.conditions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.condition {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.conditionLabel {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.set {
  display: grid;
  gap: 10px;
  min-width: 0;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
}

.set:disabled {
  opacity: 0.7;
}

.legend {
  padding: 0 6px;
  color: var(--ink-2);
  font-size: var(--t-dense);
  font-weight: 650;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  align-items: start;
  gap: 12px 16px;
}

.wide {
  grid-column: 1 / -1;
}

.checks {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: var(--h-ctl);
  font-size: var(--t-dense);
}

.keyState {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin: 0 0 12px;
}

.meta {
  color: var(--muted);
  font-size: var(--t-dense);
}

.actions {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
}

.test {
  display: grid;
  gap: 8px;
  justify-items: start;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.spendFacts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px 16px;
  margin: 0 0 12px;
}

.spendFacts dt {
  margin-bottom: 3px;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.spendFacts dd {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-variant-numeric: lining-nums tabular-nums;
}

.table {
  width: 100%;
  margin: 0 0 12px;
  border-collapse: collapse;
  font-size: var(--t-dense);
}

.table th,
.table td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--line);
  text-align: left;
  vertical-align: top;
}

.table thead th {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.table tbody th {
  font-weight: 500;
  text-transform: capitalize;
}

.table th.num,
.table td.num {
  text-align: right;
  font-variant-numeric: lining-nums tabular-nums;
}
